<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <span class="action stock-transfer-toolbar">
    <app-add-edit-modal (refresh)="onRefreshList()"></app-add-edit-modal>
    <span
      nz-tooltip
      [nzTooltipTitle]="setOfCheckedId.size ? null : 'Bitte zuerst Umlagerungen auswählen.'"
    >
      <button
        nz-button
        nzType="primary"
        [disabled]="!setOfCheckedId.size"
        (click)="onDownloadCSV()"
      >
        <i nz-icon nzType="download" nzTheme="outline"></i>
        Auswertung
      </button>
    </span>
  </span>
  <div class="uncompleted-orders-checkbox-wrapper">
    <label
      nz-checkbox
      [(ngModel)]="showOpenTransfers"
      (ngModelChange)="showOpenTransfersChange()"
    >Nicht abgeschlossene Umlagerungen</label>
  </div>
</app-table-header>
<nz-table appColumnLayout id="stock-transfer-list-table"
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  class="stores-transfer-list"
  >
  <thead>
    <tr>
      <th data-col-key="selection"
        [(nzChecked)]="checked"
        [nzIndeterminate]="indeterminate"
        (nzCheckedChange)="onAllChecked($event)"
        nzWidth="48px"
      ></th>
      <th nzColumnKey="id" [nzSortFn]="true" nzWidth="72px">#ID</th>
      <th nzColumnKey="originStore.name" [nzSortFn]="true">Ursprungslager</th>
      <th nzColumnKey="targetStore.name" [nzSortFn]="true">Ziellager</th>
      <th nzColumnKey="worker.fullName" [nzSortFn]="true">Mitarbeiter</th>
      <th nzColumnKey="deliveryDate" [nzSortFn]="true" nzWidth="130px">Liefertermin</th>
      <th
        nzColumnKey="status"
        [nzSortFn]="true"
        [nzFilters]="statusFilters"
        [nzFilterMultiple]="true"
        [nzFilterFn]="true"
        (nzFilterChange)="filtersChanged()"
        nzWidth="110px"
      >Status</th>
      <th nzColumnKey="actions" nzRight nzWidth="220px"></th>
    </tr>
  </thead>
  <tbody>
    @for (result of data.results; track result) {
      <tr>
        <td [nzChecked]="setOfCheckedId.has(result.id)" (nzCheckedChange)="onItemChecked(result.id, $event)"></td>
        <td>{{ result.id }}</td>
        <td class="cell-ellipsis" [title]="result.originStore.name">{{ result.originStore.name }}</td>
        <td class="cell-ellipsis" [title]="result.targetStore.name">{{ result.targetStore.name }}</td>
        <td class="cell-ellipsis" [title]="result.worker.fullName">{{ result.worker.fullName }}</td>
        <td class="cell-nowrap">{{ result.deliveryDate | dateFormat }}</td>
        <td class="cell-nowrap">{{ result.status | statusFormat }}</td>
        <td nzRight>
          <div class="actions">
            @if (statusTypes[result.status] === statusTypes.Open) {
              <app-icon-button
                icon="send"
                [ariaLabel]="'Umlagerung versenden: #' + result.id"
                (pressed)="dispatchTransfer(result.id)"
              ></app-icon-button>
            }
            @if (statusTypes[result.status] === statusTypes.Dispatched) {
              <app-icon-button
                icon="book"
                [ariaLabel]="'Umlagerung buchen: #' + result.id"
                (pressed)="bookTransfer(result.id)"
              ></app-icon-button>
            }
            @if (statusTypes[result.status] !== statusTypes.Canceled && statusTypes[result.status] !== statusTypes.Booked) {
              <app-icon-button
                icon="stop"
                [ariaLabel]="'Umlagerung stornieren: #' + result.id"
                (pressed)="cancelTransfer(result.id)"
              ></app-icon-button>
            }
            <app-add-edit-modal #modal>
              <span trigger>
                <app-icon-button
                  icon="eye"
                  [ariaLabel]="'Umlagerungsauftrag öffnen: #' + result.id"
                  (pressed)="modal.showModal(result)"
                ></app-icon-button>
              </span>
            </app-add-edit-modal>
            @if (result.documentKey) {
              <app-download-document [documentKey]="result.documentKey"></app-download-document>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
